<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('nav.aboutBtn')" />

    <aboutUs />
    <team />

    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import aboutUs from "./../components/aboutUs.vue";
import team from "./../components/team.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "About",
  components: {
    navMenu,
    hero,
    aboutUs,
    team,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
